export default __webpack_public_path__ + "static/media/Elder Wand - Img - Wip 2_00.79acc553.jpg";